import React from "react";

export const WelcomePage = () => {
  return (
    <div className="hidden-container ">
      <i className="nes-logo"></i>
      <h2> Hola, bienvenido a tu espacio para ver tus notas</h2>
      <p>
        Al lado izquierdo podrás crear una nueva nota, filtrarlas o revisar tus
        notas creadas.
      </p>
    </div>
  );
};
